<template lang="pug">
div
  v-card.pa-4.my-4(v-for="index in count", :key="index")
    v-row
      v-col.d-flex.justify-center(cols="3", sm="2")
        v-skeleton-loader(:loading="true", type="avatar", :max-width="100")
      v-col(cols="9", sm="10")
        v-skeleton-loader.mb-4(:loading="true", type="heading")
        v-skeleton-loader(:loading="true", type="text@5")
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "PostListSkeleton",
  props: {
    count: { type: Number, default: 1 },
  },
})
</script>
